import { Component, h } from '@stencil/core';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';

@Component({
  tag: 'random-actions',
  styleUrl: 'random-actions.css',
  shadow: false,
})
export class RandomActions {
  private translations: TranslationValues;

  private topTitle: string;
  private buttonText: string;

  constructor() {}

  async componentWillLoad() {
    this.translations = await Translations.getValues();
  }

  buttonClick() {}

  render() {
    return (
      <div class="container">
        <div class="row">
          <div class="text-center">
            <h1>{this.topTitle}</h1>
          </div>
          <div class="pos-relative show-bottom">
            <div class="btn-buletin">
              <button class="main-button" onClick={() => this.buttonClick()}>
                {this.buttonText}
              </button>
              <p class="main-text font-size-18 text-right mb-0">{this.translations.GlobalValues.FooterText}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
